//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { useMemo, memo, useCallback, useEffect, useState } from 'react';
import { BzButton, BzCard, BzChip } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getExchangeWiseScripInfo, getScripOrderInfo } from '../../redux/actions/orders';
import { handleModal } from '../../redux/actions/modals';
import { convertAlertToWatchlistGrid, getAppInfoData, ORDER_ENTRY_GRID_REF } from '../../utils/global_functions';//ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve 
import AlertNameDetails from './AlertNameDetails';
import ZeroStates from '../ZeroStates';
import { APP_INFO_PARAMS, TL_INDEX, TRADING_NOT_ALLOWED_MSG, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { uniqBy } from 'lodash';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { useWFHMessages } from '../../hooks';
import { _checkSegmetAllowed } from '../../controllers';
import { toastConfig } from '../../redux/actions/toast';



const AlertLog = ({ isVertical, arrAlertAttributes, AlertPortfolio, arrAlertLogAttributes, bShowDeleteCheckbox, handleSelectAlertForDelete, handleDeleteSingleAlert, arrSelectedDeleteAlert }) => {
    const dispatch = useDispatch();
    const trigerredAlerts = useSelector(state => state?.alerts?.trigerredAlerts);
    const strSearchAlertBySymbol = useSelector(state => state?.alerts?.strSearchAlertBySymbol);
    const objFilterAlertFromModal = useSelector(state => state?.alerts?.objFilterAlertFromModal);
    const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- Start 
    const [arrActiveAlert, setArrActiveAlerts] = useState([]);
    const updateAlertWithTouchlineData = (arrTouchLineData) => {
        setArrActiveAlerts(arrAlerts => {
            if (arrAlerts?.length > 0) {
                let arrFilt = arrAlerts?.filter((alert) => alert?.mktIdToken === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
                for (let i = 0; i < arrFilt?.length; i++) {
                    const nIndex = arrAlerts?.findIndex(item => item?.serverAlertId === arrFilt[i]?.serverAlertId);
                    arrFilt[i].ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    arrFilt[i].changeInPrice = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                    arrFilt[i].changeInPercent = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                    arrAlerts[nIndex] = arrFilt[i];
                }
                return [...arrAlerts];
            } else { }
        });
    };

    useWFHMessages('touchline', (e) => {
        updateAlertWithTouchlineData([...e.detail]);
    });

    useEffect(() => {
        const arrAlertsData = AlertPortfolio ? arrAlertLogAttributes : isVertical === false ? trigerredAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) : trigerredAlerts || [];
        setArrActiveAlerts(arrAlertsData);
        const arrUniqAlert = arrAlertsData?.length > 0 && uniqBy(arrAlertsData, 'mktIdToken');

        if (arrUniqAlert?.length > 0) {
            const arrAlertsForSubscription = arrUniqAlert?.map((scrip) => {
                return { exchangeId: scrip.segmentId, token: scrip.nToken };
            });
            sendTouchlineRequest(arrAlertsForSubscription);
        }

        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (arrUniqAlert?.length > 0) {
            arrUniqAlert?.forEach((each) => {
                let key = each?.mktIdToken;
                if (objLastTickData[key]) {
                    updateAlertWithTouchlineData(objLastTickData[key]);

                }
            });
        }
    }, [AlertPortfolio, trigerredAlerts, arrAlertAttributes, dispatch, scripOverviewData, isVertical]);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- End 

    // Vinit R - 24-04-2024 BT-107432 Breeze - Alerts -- Start
    const filterAlerts = (arr, objefilter) => {
        // Deepti B. 107432 Breez Alerts: category and alert filter fixes -- start
        return arr?.filter(item => {
            const categoryMatch = objefilter?.selectedCategory ? item.category === objefilter?.selectedCategory : true;
            const alertMatch = objefilter?.selectedAlerts ? item.factor1 === objefilter?.selectedAlerts : true;
            return categoryMatch && alertMatch;
        });
        // Deepti B. 107432 Breez Alerts: category and alert filter fixes -- end
    };

    let arrTrigerredAlertsScripData = useMemo(() => {
        let temp = arrActiveAlert;
        if (Object.keys(objFilterAlertFromModal)?.length) {
            temp = filterAlerts(temp, objFilterAlertFromModal);
        }
        temp = strSearchAlertBySymbol ?
            temp?.filter((scrip) => scrip?.symbol?.toUpperCase()?.includes(strSearchAlertBySymbol?.toUpperCase()))
            : temp;

        return temp;

    }, [trigerredAlerts, arrActiveAlert, objFilterAlertFromModal, strSearchAlertBySymbol]);
    // Vinit R - 24-04-2024 BT-107432 Breeze - Alerts -- End
    const objLoginSession = useSelector(state => state.auth.objLoginSession);

    const handlePlaceOrder = useCallback(async (data, nIsBuyOrSell = 0, activeExchangeName = 'NSE') => {
        const orderInfo = convertAlertToWatchlistGrid(data);
        if (_checkSegmetAllowed(orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], objLoginSession?.data?.exchanges)) {
            ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false);//ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve
            dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeName, scripData: orderInfo }));
            await dispatch(getExchangeWiseScripInfo(orderInfo));
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));
        }
    }, [dispatch, objLoginSession]);

    const bINesperAlert = getAppInfoData(APP_INFO_PARAMS.APP_NESPER_ALERT);
    const strClassName = bShowDeleteCheckbox ? 'sticky-alert-height-fifty' : 'sticky-alert-height-hundared';

    return (


        <Container fluid className='p-0 '> {/* Hari P: 12-11-2023 SAT-BT-107432 2nd Cycle  UI issue fixed */}
            {trigerredAlerts?.length > 0 ?
                <div className={strClassName}>
                    {arrTrigerredAlertsScripData?.length > 0 && arrTrigerredAlertsScripData?.map((each, i) => (
                        <BzCard key={i} className='p-0 p-2 bdr-btm'>
                            <Row className='g-0'>
                                {bShowDeleteCheckbox &&
                                    <Col md='auto'>
                                        <input type="checkbox" className='form-check-input mt-1 me-2' checked={arrSelectedDeleteAlert?.includes(each)} onChange={handleSelectAlertForDelete.bind(this, each)} />
                                    </Col>}
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size3 color-text'>{each?.symbol}</div> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}

                                    {/* <div className='chips-wrap'> */}
                                    {/* <BzChip className='chips negative-chip ms-2'>{each?.status}</BzChip> Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023 */}
                                    {/* </div> */}
                                </Col>
                                {/* Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- Start  */}
                                <Col className='d-flex justify-content-end align-self-center'>
                                    <div className='d-flex justify-content-end align-self-center'>
                                        <div className='font-medium font-size3 color-text'>{each?.ltp}</div>
                                    </div>
                                    {/* Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- End  */}
                                </Col>

                            </Row>
                            <Row className='g-0 chips-wrap mb-1'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                <Col>
                                    <BzChip className='exchange-chip text-capitalize float-start me-2'>{each?.exchange}</BzChip> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                    <AlertNameDetails alertData={each} />
                                </Col>
                                {/* Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- Start  */}

                                <Col md={4} className='d-flex justify-content-end align-self-center'>
                                    <div className='d-flex justify-content-end align-self-center'>
                                        <div className={`font-regular font-size1 color-text me-1 ${each?.changeInPercent?.split("")[0] === '+' ? "color-positive" : (each?.changeInPercent?.split("")[0] === '-' ? "color-negative" : '')} `}>{each?.changeInPrice}</div>
                                        <div className={`font-regular font-size1 color-text ${each?.changeInPercent?.split("")[0] === '+' ? "color-positive" : (each?.changeInPercent?.split("")[0] === '-' ? "color-negative" : '')} `}>({each?.changeInPercent}%)</div>
                                    </div>
                                </Col>
                                {/* Azeem K - 23-05-2024 BT-107432 Breeze - Alerts:Added Livefeed data -- End  */}
                            </Row>
                            <Row className='g-0 '>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    {/* <div className='icon-16 icon-alert icon-negative me-2'></div> */}
                                    <div className='font-medium font-size2 color-text'>{each?.alertCondition}</div>
                                </Col>
                                {!bShowDeleteCheckbox &&
                                    <Col md={4} className='d-flex justify-content-end align-items-center'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                        <BzButton className='btn btn-sm btn-positive' onClick={handlePlaceOrder.bind(this, each, 0)}>B</BzButton>
                                        <BzButton className='btn btn-sm btn-negative ms-2' onClick={handlePlaceOrder.bind(this, each, 1)}>S</BzButton>
                                        {!bINesperAlert ? <div className='icon-16 icon-delete icon-dark ms-3' onClick={handleDeleteSingleAlert?.bind(this, each)}></div> : null}
                                    </Col>
                                }
                            </Row>
                            <Row className='g-0'>
                                <Col md={6} className='text-start'>
                                    <div className='font-regular font-size1 color-subtext'>Created:<div> {each?.displayCreateDate}</div></div>
                                </Col>
                                <Col md={6} className='text-end'>
                                    <div className='font-regular font-size1 color-subtext'>Triggered:<div> {each?.triggeredTime}</div></div>
                                </Col>
                            </Row>
                        </BzCard>
                    ))}
                </div>

                :

                <div className={`zero-state-alerts zero-state-alerts-${isVertical ? 'xl' : 'sm'}`}>
                    <ZeroStates subText="No alerts triggered yet!" icon='icon-64 icon-alert icon-background-nodata mb-3 mrgauto' /> {/*Hari P: BT-107432 Breeze Alert UI Issue and added class for styling purpuse fixed 22-11-2023*/}
                </div>
            }
        </Container>



    );
};

export default memo(AlertLog);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End
